import * as React from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import AuthGuard from 'AuthGuard'
import UserLayout from 'layouts/user/Layout'
import GuestLayout from 'layouts/guest/Layout'
import NotFound from 'errors/NotFound'
import Overview from 'modules/overview/Overview'
import PriceSheet from 'modules/price-sheet/PriceSheet'
import Summary from 'modules/summary/Summary'
import OrderCreate from 'modules/order/OrderCreate'
import OrderEdit from 'modules/order/OrderEdit'
import Schedules from 'modules/schedule/Schedules'
import Account from 'modules/account/Account'
import Login from 'auth/Login'
import { AuthContext } from 'contexts/authContext'
import { getNextDeliveryDate } from 'utils/deliveryDate'

/**
 * App component
 */
const App = () => {
  const { user } = React.useContext(AuthContext)
  const nextDeliveryDate = getNextDeliveryDate()

  return (
    <BrowserRouter>
      <Routes>
        {/* User routes */}
        <Route element={<AuthGuard />}>
          <Route path="/" element={<Navigate to={"/overview/" + nextDeliveryDate} replace />} />
          <Route element={<UserLayout />}>
            <Route path="/overview/:deliveryDate" element={<Overview />} />
            <Route path="/price-sheet/:deliveryDate" element={<PriceSheet />} />
            <Route path="/summary/:deliveryDate" element={<Summary />} />
            <Route path="/orders/create" element={<OrderCreate />} />
            <Route path="/orders/edit/:orderId" element={<OrderEdit />} />
            <Route path="/schedules" element={<Schedules />} />
            <Route path="/account" element={<Account />} />
          </Route>
        </Route>

        {/* Guest routes */}
        <Route element={<GuestLayout />}>
          <Route path="/login" element={!user ? <Login /> : <Navigate to="/" replace />} />
        </Route>

        {/* Catch-all route for 404s */}
        <Route element={<GuestLayout />}>
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default App
